import { render, staticRenderFns } from "./Varification.vue?vue&type=template&id=8bdc9f5a&lang=pug&"
import script from "./Varification.vue?vue&type=script&lang=js&"
export * from "./Varification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports